import React from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationKey } from '../../i18n/translationKeys';
import { formatCurrency } from '../../utils/formatters';
import { ReceivablesRow } from '../../features/kpi/ReceivablesRow';
import { ReceivablesTile } from '../../features/kpi/ReceivablesTile';

interface FollowUpFiguresProps {
    receivablesTotal: number | null;
    totalDue: number | null;
    lang: string;
}

export const FollowUpFigures: React.FC<FollowUpFiguresProps> = ({ receivablesTotal, totalDue, lang }) => {
    const { t } = useTranslation();

    return (
        <ReceivablesRow>
            <ReceivablesTile
                testId="followup-receivables-total"
                label={t(TranslationKey.CustomerFollowUp.Recap.ReceivablesTotal)}
                value={formatCurrency(receivablesTotal, lang)}
            />
            <ReceivablesTile
                testId="followup-total-due"
                label={t(TranslationKey.CustomerFollowUp.Recap.TotalDue)}
                value={formatCurrency(totalDue, lang)}
            />
        </ReceivablesRow>
    );
};
